export default "__VITE_ASSET__CzJAqRrW__"